import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { AssignForeman } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  options?: Omit<UseMutationOptions<unknown, Error, AssignForeman>, 'mutationKey' | 'mutationFn'>
}

export const useAssignForemanRequest = ({
  options,
}: RequestParams) => {
  const api = useApiInstance()

  return useMutation<unknown, Error, AssignForeman>(
    [Entities.Projects, 'assignForeman'],
    async (payload: AssignForeman) => {
      const { data } = await api.v1AdminUsersForemansAssignToProjectPost(payload)
      return data
    },
    { ...options },
  )
}
